import { DEFAULT_LOCALE } from '@clearscore/config.i18n';

export default {
    [DEFAULT_LOCALE]: {
        appDownloadBanner: 'Log in faster next time.',
    },
};
